import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { focusManager, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/space-grotesk/wght.css';
import '@fontsource/lilita-one/latin-400.css';
import './ui/tokens.css';
import { shouldRetry } from './api/client';
import { lang, loadStrings } from './i18n/i18n';
import { initTelegram, onActivityChange, startParam } from './telegram/webapp';
import { rememberReferral } from './session/referral';
import { bootstrapSession } from './session/favorites';
import { App } from './App';
import { initAnalytics } from './analytics/analytics';

document.documentElement.lang = lang;
initTelegram();
rememberReferral(startParam());
initAnalytics();

// Возврат в приложение = «фокус»: устаревшие запросы перезапрашиваются. Кроме вкладки браузера слушаем Telegram —
// на десктоп-клиентах свёрнутая Mini App не меняет visibilityState.
focusManager.setEventListener((setFocused) => {
  const onVisibility = () => setFocused(document.visibilityState === 'visible');
  document.addEventListener('visibilitychange', onVisibility);
  const offTelegram = onActivityChange(setFocused);
  return () => { document.removeEventListener('visibilitychange', onVisibility); offTelegram(); };
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: shouldRetry, refetchOnWindowFocus: true, gcTime: 30 * 60_000 },
  },
});

await loadStrings();
void bootstrapSession();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
